import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import {
  KeyboardArrowLeft,
  KeyboardArrowRight,
  KeyboardDoubleArrowLeft,
  KeyboardDoubleArrowRight,
} from '@mui/icons-material';
import { COLORS_ADMIN_PAGE } from '../../../conf/constants';

interface MunicipalityPaginationProps {
  currentPage: number;
  totalPages: number;
  totalMunicipalities: number;
  debouncedSearchTerm: string;
  onPageChange: (page: number) => void;
}

const MunicipalityPagination: React.FC<MunicipalityPaginationProps> = ({
  currentPage,
  totalPages,
  totalMunicipalities,
  debouncedSearchTerm,
  onPageChange
}) => {
  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      mt: 2,
      p: 1,
      bgcolor: COLORS_ADMIN_PAGE.WHITE,
    }}>
      <Box>
        <Button
          variant="contained"
          onClick={() => onPageChange(currentPage - 5)}
          disabled={currentPage <= 5}
          sx={{
            bgcolor: COLORS_ADMIN_PAGE.PRIMARY,
            mr: 0.5,
            minWidth: '36px',
            px: 1,
            '&:hover': { bgcolor: COLORS_ADMIN_PAGE.PRIMARY }
          }}
        >
          <KeyboardDoubleArrowLeft />
        </Button>
        <Button
          variant="contained"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          sx={{
            bgcolor: COLORS_ADMIN_PAGE.PRIMARY,
            mr: 1,
            minWidth: '36px',
            px: 1,
            '&:hover': { bgcolor: COLORS_ADMIN_PAGE.PRIMARY }
          }}
        >
          <KeyboardArrowLeft />
        </Button>
      </Box>
      <Typography variant="body2" sx={{ color: COLORS_ADMIN_PAGE.TEXT_SECONDARY, mx: 1 }}>
        Page {currentPage} of {Math.max(totalPages, 1)}
        {debouncedSearchTerm ? ` (${totalMunicipalities} found)` : ` (${totalMunicipalities} available)`}
      </Typography>
      <Box>
        <Button
          variant="contained"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
          sx={{
            bgcolor: COLORS_ADMIN_PAGE.PRIMARY,
            ml: 1,
            minWidth: '36px',
            px: 1,
            '&:hover': { bgcolor: COLORS_ADMIN_PAGE.PRIMARY }
          }}
        >
          <KeyboardArrowRight />
        </Button>
        <Button
          variant="contained"
          onClick={() => onPageChange(currentPage + 5)}
          disabled={currentPage >= totalPages - 4 || totalPages === 0}
          sx={{
            bgcolor: COLORS_ADMIN_PAGE.PRIMARY,
            ml: 0.5,
            minWidth: '36px',
            px: 1,
            '&:hover': { bgcolor: COLORS_ADMIN_PAGE.PRIMARY }
          }}
        >
          <KeyboardDoubleArrowRight />
        </Button>
      </Box>
    </Box>
  );
};

export default MunicipalityPagination;